<template>
  <div class="dashboard-container">
    <div class="dashboard-search-bar">
      <div class="dashboard-search-item">
        <el-select v-model="option" size="large" @change="handleOnchange">
          <el-option v-for="item in options" 
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dashboard-search-item">
        <el-date-picker
          v-model="date"
          type="datetimerange"
          size="large"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          @change="() => option = 'custom'"
          start-placeholder="Start Date"
          end-placeholder="End Date">
        </el-date-picker>
      </div>
      <div class="dashboard-search-item">
        <el-button type="primary" size="large" @click="handleQuery">Search</el-button>
      </div>
    </div>

    <div class="dashboard-chart">
      <div class="chart-container">
        <div class="chart-title-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill="#4e565b" d="M8.51464 0V1.80338H5.9899C5.97863 1.80338 5.96736 1.80338 5.95609 1.80338C5.77012 1.82029 5.62782 1.97668 5.62923 2.16406V3.96744H3.82585C3.62719 3.96744 3.46517 4.12946 3.46517 4.32811V7.19098L1.83085 7.732C1.08978 7.97855 0.74319 8.82812 1.04188 9.52411C1.04188 9.52833 1.04188 9.53115 1.04188 9.53538L2.38314 12.3532V15.5429C1.93089 15.7528 1.37156 15.8359 1.00806 15.8359C0.789684 15.8359 0.593848 15.8021 0.365607 15.8021C0.235989 15.8007 0.114825 15.8683 0.0486069 15.9811C-0.0162023 16.0938 -0.0162023 16.2318 0.0486069 16.3446C0.114825 16.4573 0.235989 16.5249 0.365607 16.5235C0.498043 16.5235 0.720648 16.5573 1.00806 16.5573C1.52372 16.5573 2.25775 16.4065 2.89034 16.0276C2.92275 16.0135 2.95374 15.9937 2.98051 15.9712C2.98333 15.9698 2.98896 15.9726 2.99178 15.9712C3.64692 16.4009 4.43026 16.5573 4.9755 16.5573C5.51792 16.5573 6.30549 16.3953 6.95922 15.9712C7.61435 16.4009 8.3977 16.5573 8.94294 16.5573C9.48536 16.5573 10.2729 16.3953 10.9267 15.9712C11.5818 16.4009 12.3651 16.5573 12.9104 16.5573C13.4359 16.5573 14.1868 16.3995 14.8265 16.005C14.8885 16.0402 14.9589 16.0557 15.0294 16.0501C15.6549 16.4164 16.3692 16.5573 16.8778 16.5573C17.1652 16.5573 17.4329 16.515 17.6668 16.422C17.8542 16.3474 17.9443 16.136 17.8697 15.9487C17.795 15.7613 17.5837 15.6711 17.3963 15.7458C17.2695 15.7965 17.0962 15.8359 16.8778 15.8359C16.4735 15.8359 15.8381 15.7289 15.3675 15.464V12.3306L16.6637 9.53538V9.52411C17.0088 8.81825 16.6087 7.97714 15.8747 7.732L14.2855 7.20225V4.32811C14.2855 4.12946 14.1234 3.96744 13.9248 3.96744H12.1214V2.16406C12.1214 1.9654 11.9594 1.80338 11.7607 1.80338H9.23599V0H8.51464ZM6.35058 2.52473H11.4V4.32811C11.4 4.52677 11.5621 4.68879 11.7607 4.68879H13.5641V6.96556L8.98802 5.43269C8.93026 5.41014 8.86827 5.40169 8.80769 5.41014C8.79219 5.41719 8.77669 5.42423 8.7626 5.43269L4.18652 6.95429V4.68879H5.9899C6.18856 4.68879 6.35058 4.52677 6.35058 4.32811V2.52473ZM8.87531 6.14277L15.6493 8.41954C15.9944 8.53507 16.172 8.91828 16.0212 9.21979C16.017 9.22401 16.0142 9.22683 16.0099 9.23106L14.6799 12.1165C14.6588 12.163 14.6475 12.2123 14.6461 12.263V15.3175C14.1756 15.6866 13.3809 15.8359 12.9104 15.8359C12.4342 15.8359 11.6311 15.6866 11.1634 15.3062C11.0295 15.1949 10.8351 15.1949 10.7012 15.3062C10.2335 15.6866 9.41915 15.8359 8.94294 15.8359C8.46673 15.8359 7.66367 15.6866 7.19591 15.3062C7.06207 15.1949 6.86764 15.1949 6.7338 15.3062C6.26605 15.6866 5.45171 15.8359 4.9755 15.8359C4.4993 15.8359 3.69623 15.6866 3.22848 15.3062C3.19184 15.2752 3.14958 15.2527 3.10449 15.2386V12.263C3.1059 12.208 3.09322 12.1545 3.07068 12.1052L1.70687 9.23106C1.57162 8.91687 1.7266 8.53366 2.06755 8.41954L8.87531 6.14277ZM5.80956 9.01691C5.51088 9.01691 5.26855 9.42126 5.26855 9.9186C5.26855 10.4159 5.51088 10.8203 5.80956 10.8203C6.10825 10.8203 6.35058 10.4159 6.35058 9.9186C6.35058 9.42126 6.10825 9.01691 5.80956 9.01691ZM11.9411 9.01691C11.6424 9.01691 11.4 9.42126 11.4 9.9186C11.4 10.4159 11.6424 10.8203 11.9411 10.8203C12.2397 10.8203 12.4821 10.4159 12.4821 9.9186C12.4821 9.42126 12.2397 9.01691 11.9411 9.01691ZM2.95797 16.6587C2.88611 16.6686 2.8199 16.701 2.76636 16.7489C2.29861 17.1293 1.48427 17.2786 1.00806 17.2786C0.789684 17.2786 0.593848 17.2448 0.365607 17.2448C0.235989 17.2434 0.114825 17.3111 0.0486069 17.4238C-0.0162023 17.5365 -0.0162023 17.6745 0.0486069 17.7873C0.114825 17.9 0.235989 17.9676 0.365607 17.9662C0.498043 17.9662 0.720648 18 1.00806 18C1.55049 18 2.33806 17.838 2.99178 17.4139C3.64692 17.8436 4.43026 18 4.9755 18C5.51792 18 6.30549 17.838 6.95922 17.4139C7.61435 17.8436 8.3977 18 8.94294 18C9.48536 18 10.2729 17.838 10.9267 17.4139C11.5818 17.8436 12.3651 18 12.9104 18C13.4528 18 14.2404 17.838 14.8941 17.4139C15.5492 17.8436 16.3326 18 16.8778 18C17.1652 18 17.4329 17.9577 17.6668 17.8647C17.8542 17.7901 17.9443 17.5787 17.8697 17.3914C17.795 17.204 17.5837 17.1138 17.3963 17.1885C17.2695 17.2392 17.0962 17.2786 16.8778 17.2786C16.4016 17.2786 15.5985 17.1293 15.1308 16.7489C14.9969 16.6376 14.8025 16.6376 14.6687 16.7489C14.2009 17.1293 13.3866 17.2786 12.9104 17.2786C12.4342 17.2786 11.6311 17.1293 11.1634 16.7489C11.0295 16.6376 10.8351 16.6376 10.7012 16.7489C10.2335 17.1293 9.41915 17.2786 8.94294 17.2786C8.46673 17.2786 7.66367 17.1293 7.19591 16.7489C7.06207 16.6376 6.86764 16.6376 6.7338 16.7489C6.26605 17.1293 5.45171 17.2786 4.9755 17.2786C4.4993 17.2786 3.69623 17.1293 3.22848 16.7489C3.16367 16.6911 3.07913 16.6587 2.99178 16.6587C2.98051 16.6587 2.96924 16.6587 2.95797 16.6587Z"/>
          </svg>
          <div class="chart-title">Customer Performance:</div>
        </div>
        <el-row :gutter="10">
          <el-col :span="24" style="padding-bottom: 0px;">
            <customerPerformanceTab :key="componentKey" :startDate="startDate" :endDate="endDate" :mock="mock" />
          </el-col>
        </el-row>
      </div>

      <div class="flex flex-col justify-between h-full gap-4 xs:flex-row">
        <div class="flex-grow chart-container chart-pie">
          <div class="chart-title-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill="#4e565b" fill-rule="evenodd" clip-rule="evenodd" d="M9.0125 1C9.6125 0.36875 10 0 10 0C10.1363 0.45375 10.2925 0.885 10.4638 1.2975C11.4788 3.73 13.055 5.485 14.46 7.0475C16.0975 8.87 17.5 10.4312 17.5 12.5C17.5 14.4891 16.7098 16.3968 15.3033 17.8033C13.8968 19.2098 11.9891 20 10 20C8.01088 20 6.10322 19.2098 4.6967 17.8033C3.29018 16.3968 2.5 14.4891 2.5 12.5C2.5 8.335 6.975 3.14625 9.0125 1ZM9.52875 2.27625C8.72601 3.14492 7.96314 4.0496 7.2425 4.9875C6.335 6.175 5.4475 7.4975 4.7925 8.825C4.13 10.1663 3.75 11.4225 3.75 12.5C3.75 14.1576 4.40848 15.7473 5.58058 16.9194C6.75269 18.0915 8.3424 18.75 10 18.75C11.6576 18.75 13.2473 18.0915 14.4194 16.9194C15.5915 15.7473 16.25 14.1576 16.25 12.5C16.25 10.9987 15.255 9.80375 13.5238 7.875L13.4862 7.835C12.1875 6.3875 10.625 4.65125 9.52875 2.27625Z"/>
              <path fill="#4e565b" fill-rule="evenodd" clip-rule="evenodd" d="M5.69141 9.72109C6.71641 7.66984 7.83766 6.27984 8.30766 5.80859L9.19266 6.69359C8.83016 7.05609 7.78266 8.33234 6.80891 10.2811L5.69141 9.72109Z"/>
            </svg>
            <div class="chart-title">Total Quantity Loaded: <span class="number">{{ totalQuantityLoaded }}</span></div>
          </div>
          <div class="flex flex-col" v-if="showTotalQuantiyLoadedPies">
            <pieChart :key="componentKey" :startDate="startDate" :endDate="endDate" :optionData="varianceOptions"/>
            <pieChart :key="componentKey" :startDate="startDate" :endDate="endDate" :optionData="cargoMovementOptions"/>
          </div>
          <div v-if="!showTotalQuantiyLoadedPies">
            No data found
          </div>
        </div>
        <div class="flex-grow chart-container chart-pie">
          <div class="chart-title-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path fill="#4e565b" d="M5.8135 1.67188L1.0835 3.17793L4.29455 6.95789L4.8424 5.04578C6.7717 5.69031 8.0135 6.57117 8.77834 7.55086C9.6635 8.67664 9.95998 9.9657 9.88264 11.3708C9.72795 14.1809 7.91897 17.3735 6.28186 19.3415L7.46779 20.3298C8.8299 18.7013 10.2865 16.3938 10.9998 13.9059C11.7131 16.3938 13.1697 18.7013 14.5319 20.3298L15.7178 19.3415C14.0807 17.3735 12.2717 14.1809 12.117 11.3708C12.0397 9.9657 12.3362 8.67664 13.2213 7.55086C13.9862 6.57117 15.228 5.69031 17.153 5.04578L17.703 6.95789L20.917 3.17793L16.1862 1.67188L16.7276 3.55992C14.5447 4.2818 13.0022 5.32078 12.001 6.59695C11.5584 7.16414 11.2319 7.7657 10.9998 8.39734C10.7678 7.7657 10.4412 7.16414 9.99865 6.59695C8.99748 5.32078 7.4549 4.2818 5.27209 3.55992L5.8135 1.67188Z"/>
            </svg>
            <div class="chart-title">Lifted Product Breakdown</div>
          </div>
          <div class="flex flex-col" v-if="showLiftedProductBreakdownPies">
            <pieChart :key="componentKey" :startDate="startDate" :endDate="endDate" :optionData="whiteOilOptions"/>
            <pieChart :key="componentKey" :startDate="startDate" :endDate="endDate" :optionData="blackOilOptions"/>
          </div>
          <div class="notfound" v-if="!showLiftedProductBreakdownPies">
            No data found
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment"
import nominationCompletedTab from "./nomination-completed-tab.vue";
import customerPerformanceTab from "./customer-performance.vue";
import pieChart from "./pie-chart.vue";
import { getDashboardTotalQuantityLoaded, getDashboardLiftedProductBreakdown } from  "@/services/form";
 
export default {
  name: "DashboardCharts",
  components: {
    nominationCompletedTab,
    customerPerformanceTab,
    pieChart,
  },
  data() {
    return {
      componentKey: 0,
      option: 'month',
      mock: false,
      options: [
        { label: 'Week', value: 'week' },
        { label: 'Month', value: 'month' },
        { label: 'Year', value: 'year' },
        { label: 'Custom', value: 'custom' },
      ],
      date: null,
      startDate: "", 
      endDate: "",
      sortOrder: "desc",
      totalQuantityLoaded: 0,
      showTotalQuantiyLoadedPies: false,
      showLiftedProductBreakdownPies: false,
      varianceOptions: {},
      cargoMovementOptions: {},
      whiteOilOptions: {},
      blackOilOptions: {},
    }
  },
  async created() {
    this.handleOnchange()
    await this.handleQuery()
    await this.getData()
  },
  methods: {
    handleOnchange() {
      let date1 = moment().format('YYYY-MM-DD HH:mm:ss')
      let date2 = moment().format('YYYY-MM-DD HH:mm:ss')
      if(this.option != 'custom') {
        date1 = moment().startOf(this.option).format('YYYY-MM-DD HH:mm:ss')
        date2 = moment().endOf(this.option).format('YYYY-MM-DD HH:mm:ss')
      }
      this.date = [ date1, date2 ]
    },
    async handleQuery() {
      this.startDate = this.date[0]
      this.endDate = this.date[1]
      this.componentKey += 1
      this.getData()
    },
    async getData() {
      const param = {
        "startDate": this.startDate, 
        "endDate": this.endDate,
      }

      const res1 = await getDashboardTotalQuantityLoaded(param)
      if(res1?.data){
        this.totalQuantityLoaded = res1.data.totalQuantityLoaded?.toFixed(3) + " MT";
        this.showTotalQuantiyLoadedPies = true;
        this.varianceOptions = {
          title: "Variance",
          data: this.handleResData(res1.data.variance),
          color: ['#625cf3','#4daaac'],
        }
        this.cargoMovementOptions = {
          title: "Cargo Movement",
          data: this.handleResData(res1.data.cargoMovement),
          color: ['#FA09B6','#193364'],
        }
      }else{
        this.totalQuantityLoaded = "No data found";
        this.showTotalQuantiyLoadedPies = false;
      }

      const res2 = await getDashboardLiftedProductBreakdown(param)
      if(res2?.data){
        this.showLiftedProductBreakdownPies = true;
        this.whiteOilOptions = {
          title: "White Product",
          data:  this.handleResData(res2.data.whiteOil),
          color: ['#e7b749','#ed853f'],
        }
        this.blackOilOptions = {
          title: "Black Product",
          data: this.handleResData(res2.data.blackOil),
          color: ['#2f2b5d','#ea387b','#47979b','#605aeb','#e8833a'],
        }
      }else{
        this.showLiftedProductBreakdownPies = false;
      }
    },
    handleResData(resData){
      // format res data for vue3-echart
      if(resData){
        const data = Object.entries(resData).map(([key, value]) => {
          // name: key.charAt(0).toUpperCase() + key.slice(1),
          // value: value.toFixed(3) ?? 0
          let formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
          formattedKey = formattedKey.replace(/Oil/g, ' Product');

          // let formattedValue = value ? value.toFixed(3) : 0.000
          let formattedValue = value?.toFixed(3) ?? 0.000

          return {
            name: formattedKey,
            value: formattedValue
          };

        });
        return data
      }
      return []
    },
  }
}
</script>
<style lang="scss" scoped>
.dashboard-container {
  height: 100%; 
  overflow-x: hidden;
  overflow-y: auto;

  .dashboard-search-bar {
    box-sizing: border-box;
    width: 100%;

    .dashboard-search-item {
      display: inline-block;
      padding-right: 10px;
      padding-bottom: 10px;
    }
  }

  .chart-title-box{
    font-weight: 700;
    line-height: 20px;
    color: #4c565c;
    display: flex; 
    align-items: center;
    padding-bottom: 20px;
  }

  .chart-title{
    // color: #435AD3;
    // font-family: Roboto;
    padding-left: 10px;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 104.438%;

    .number{
      // color: #435AD3;
      // font-family: Roboto;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      // line-height: 104.438%;
    }
  }

  .chart-container{
    overflow-x: auto;
    scrollbar-width: thin;
    background-color: white; 
    border: 1px solid #E5E5E5; 
    border-radius: 10px; 
    padding: 20px 20px 10px 20px;
    margin-bottom: 10px;
    // max-width: 500px;
    // min-width: 45%;
    // width: auto;
  }

  .chart-pie{
    max-width: 1000px;
  }

  .pies {
    overflow-x: auto;
  }

  .pie{
    width: 60%;
    // height: auto;
  }

  .bordered-col {
    border-right: 1px solid #A9AEB9;   
  }

  @media (max-width: 768px) {
    .pie{
      width: auto;
    }

    .bordered-col {
      border-right: none;
    }
  }

  .notfound{
    text-align: center;
    // width: 600px;
    padding: 150px 0px;
  }
}
</style>